// Core
import React from "react"
import styled from "styled-components"

// General components
import Title from "../../../../../../components/Title"

// Style
import size from "../../../../../../styles/size"

const Container = styled.div`
  width: 100%;
  margin-left: 12rem;
  margin-top: 2.3rem;

  p {
    margin-top: 3rem;
  }

  @media (max-width: ${size.laptop}) {
    margin-top: 6rem;
    margin-left: 0px;
  }
`

const ColContainer = styled.div`
  display: flex;

  @media (max-width: ${size.laptop}) {
    display: inline;
  }
`

const Col1 = styled.div`
  width: 100%;
  max-width: 250px;

  @media (max-width: ${size.laptop}) {
    max-width: initial;
  }
`

const Col2 = styled.div`
  margin-left: 20px;

  width: 100%;
  max-width: 250px;

  @media (max-width: ${size.laptop}) {
    margin-left: 0;
    max-width: initial;
  }
`

const Schedule = styled.div`
  padding: 2rem;
  border-radius: 5px;
  background-color: #555555;
  color: #ffffff;

  /* width: 100%; */
  /* max-width: 400px; */

  margin-bottom: 15px;

  font-size: 1.4rem;

  .dayHour {
    margin-bottom: 8px;
  }

  .day {
    font-weight: 600;
    /* font-size: 1.7rem; */
    /* text-decoration: underline; */
  }
`

export default function ScheduleContainer() {
  return (
    <Container>
      <Title style={{ marginBottom: "40px" }}>Programação Semanal</Title>

      <ColContainer>
        <Col1>
          <Schedule>
            <div className="dayHour">
              <span className="day">DOMINGO</span> | 09h
            </div>
            <div>ESCOLA BÍBLICA</div>
          </Schedule>

          <Schedule>
            <div className="dayHour">
              <span className="day">DOMINGO</span> | 10h30 | 19h
            </div>
            <div>CULTO DA FAMÍLIA</div>
          </Schedule>

          <Schedule>
            <div className="dayHour">
              <span className="day">QUARTA</span> | 20h
            </div>
            <div>CULTO DA VITÓRIA</div>
          </Schedule>
        </Col1>

        <Col2>
          <Schedule>
            <div className="dayHour">
              <span className="day">SEXTA</span> | 21h
            </div>
            <div>CELEBRAÇÃO JOVEM</div>
          </Schedule>

          <Schedule>
            <div className="dayHour">
              <span className="day">SÁBADO</span> | 09h
            </div>
            <div>CAFÉ COM DEUS</div>
          </Schedule>

          <Schedule>
            <div className="dayHour">
              <span className="day">SÁBADO (1º e 3º)</span> | 20h
            </div>
            <div>CULTO DOS ADOLAS</div>
          </Schedule>
        </Col2>
      </ColContainer>
    </Container>
  )
}
